import { ProductsBreakdown as UIProductsBreakdown } from '@mews-distributor/ui';
import { useFeatureFlag } from '@mews/framework/feature-flags';
import { FeatureFlag } from '@mews-distributor/common';
import { getIsFxMulticurrencyServiceEnabled } from '../../../../modules/app/selectors';
import {
    getEnhancedProductOrderPrices,
    getProductOrdersTotalPrice,
    getProductOrdersTotalPriceInSelectedCurrency,
} from '../../../../modules/productOrders/selectors';
import { WithReservationId } from '../../../../types/selectors/selectorPropTypes';
import { useAppSelector } from '../../../../utils/redux';
import { hasSelectedEnterpriseNetPricing } from '../../../../selectors/views/selectedEnterprise/selectedEnterprise';

type ProductsBreakdownProps = WithReservationId;

export const ProductsBreakdown = ({ reservationId }: ProductsBreakdownProps) => {
    const isFxMulticurrencyServiceEnabled = useAppSelector((state) => getIsFxMulticurrencyServiceEnabled(state));
    const readProductClassificationEnabled = useFeatureFlag(FeatureFlag.enableReadProductClassification);
    const hasNetPricing = useAppSelector((state) => hasSelectedEnterpriseNetPricing(state, {}));

    const items = useAppSelector((state) =>
        getEnhancedProductOrderPrices(state, {
            reservationId,
            shouldSelectedCurrencyBeUsed: isFxMulticurrencyServiceEnabled,
            useClassificationForPriceVisibility: readProductClassificationEnabled || hasNetPricing,
        })
    );

    const productsTotalPrice = useAppSelector((state) =>
        isFxMulticurrencyServiceEnabled
            ? getProductOrdersTotalPriceInSelectedCurrency(state, reservationId)
            : getProductOrdersTotalPrice(state, { reservationId })
    );

    return <UIProductsBreakdown items={items} productsTotalPrice={productsTotalPrice} />;
};
